import http from "../http";
import Service from "../../Service";

export default class RmsIntegrationService extends Service {
    IMPORT_PROPOSAL_PATH = "clients/integrations/rms/import-proposal";

    importProposal(proposalId) {
        return http.post(
            this.IMPORT_PROPOSAL_PATH,
            { proposal_id: proposalId },
            { headers: this.getHeaders() }
        );
    }
}
